import { Col, Row, Stack } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import "./financial-report.css";
import { financialReportList } from "constants/financialReport";
function FinancialReport() {
  const [tags, setTags] = useState([]);
  const [activeTag, setActiveTag] = useState("");

  useEffect(() => {
    let uniqueTags = [...new Set(financialReportList.map((item) => item.tag))];
    setTags(uniqueTags);
    setActiveTag(uniqueTags[0]);
  }, []);
  return (
    <>
      <div className="container page">
        <h1 className="page-title">Financial Report</h1>
        {/* todo: button active color */}
        <Stack direction="horizontal" gap={3}>
          {tags.map((item, index) => {
            return (
              <div
                className={activeTag === item ? "btn-tag active" : "btn-tag"}
                onClick={() => setActiveTag(item)}
              >
                {item}
              </div>
            );
          })}
        </Stack>

        <div className="report-section">
          <Row>
            {financialReportList
              .filter((x) => x.tag === activeTag)
              .map((item, index) => (
                <Col md={4}>
                  <div className="report-card d-flex flex-column justify-content-between content">
                    <div>
                      <h1>
                        {item.title.length < 100
                          ? item.title
                          : item.title.substring(0, 100) + "..."}
                      </h1>
                    </div>
                    <div>
                      <p>
                        {item.description.length < 130
                          ? parse(item.description)
                          : parse(item.description.substring(0, 130)) + "..."}
                      </p>
                      <div className="d-flex justify-content-between align-items-baseline report-link">
                        <Link to={item.link} target="_blank">
                          View Report
                        </Link>
                        <p>{item.date}</p>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
          </Row>
        </div>
      </div>
    </>
  );
}

export default FinancialReport;
